/**
 * BGM-Zuordnung zu Spielphasen (Phase 1–3).
 * Pro Phase ein eigener Pool von Track-Dateinamen; die Auswahl erfolgt zufällig aus dem jeweiligen Pool
 * (siehe sound.js pickFromPool). Nach Ende eines Tracks wird der nächste wieder zufällig aus demselben Pool gewählt.
 * Dateien liegen in public/assets/audio/bgm/ (siehe scripts/setup-bgm.mjs, docs/CREDITS-Audio.md).
 */
export const BGM_BASE = '/assets/audio/bgm';

/** Pool pro Phase: Liste von Dateinamen (nur Name, ohne Pfad). Je Phase andere Tracks; Phase 2 teilt technochiptale mit Phase 1. */
export const BGM_POOL_BY_PHASE = {
  1: [
    'retroturnaround-stage1-remix.ogg',
    'technochiptale.ogg',
  ],
  2: [
    'midnight-drive.ogg',
    'technochiptale.ogg',
  ],
  3: [
    'jrpg-end-dungeon.mp3',
    '8bit-haunted-house.mp3',
  ],
};
